import { render, staticRenderFns } from "./SubscriptionHistory.vue?vue&type=template&id=b0ed377a&scoped=true&"
import script from "./SubscriptionHistory.vue?vue&type=script&lang=js&"
export * from "./SubscriptionHistory.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionHistory.vue?vue&type=style&index=0&id=b0ed377a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ed377a",
  null
  
)

export default component.exports